import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { invoiceInfoValidator } from '../claimValidators';
import useStepValidation from './useStepValidation';
import InvoiceForm from './InvoiceForm';
import FileImportMessage from './FileImportMessage';
import { ClaimFileType } from '../types';
import LoadingStep from './LoadingStep';

function InvoiceInfoStep(props) {
  const {
    as: Container,
    importInvoiceState,
    claim,
    onChange,
    onNext,
    onBusy,
    extractInvoiceData,
    ...restProps
  } = props;

  const [errors, onClickNext] = useStepValidation(claim, onNext, invoiceInfoValidator);
  const [isDisabled, setIsDisabled] = useState(false);

  if (importInvoiceState === 'searching') {
    return <LoadingStep {...props} text="CLAIMS_IMPORT_INVOICE_SEARCHING" />;
  }

  return (
    <Container {...restProps} onNext={onClickNext} isDisabled={isDisabled}>
      <FileImportMessage state={importInvoiceState} fileType={ClaimFileType.INVOICE_DOCUMENT} />
      <InvoiceForm
        key="loaded"
        claim={claim}
        errors={errors}
        onChange={onChange}
        onBusy={onBusy}
        extractInvoiceData={extractInvoiceData}
      />
    </Container>
  );
}

InvoiceInfoStep.propTypes = {
  as: PropTypes.elementType.isRequired,
  claim: PropTypes.object.isRequired,
  isSubmitButton: PropTypes.bool,
  onChange: PropTypes.func,
};

export default React.memo(InvoiceInfoStep);
